import React from 'react';
import classnames from 'classnames';

import classes from './CheckLabel.scss';

type Props = {
    htmlFor: string;
    checked?: boolean;
    className?: string;
};

export const CheckLabel: React.FC<Props> = ({ htmlFor, checked, className }) => (
    <label
        htmlFor={htmlFor}
        className={classnames(classes.radioLabel, className, {
            [classes.checked]: checked,
        })}
    >
        <img src="../../../static/icons/ok.svg" alt="" />
    </label>
);
